import React from "react";

const Hint = ({ Message, messageType = "message" }) => {
  const classAppend =
    messageType === "warning" ? "bc-box-attention" : "bx-box-info";
  return <p className={classAppend}>{Message}</p>;
};

export default Hint;
